//TOPへ戻るボタン(スクロールしたら途中から表示され、footer手前で止まる)
$(function(){
  $("#js-pageTop").hide();
  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 100) {
      $("#js-pageTop").fadeIn();
    } else {
      $("#js-pageTop").fadeOut();
    }
    scrollHeight = $(document).height();
    scrollPosition = window.innerHeight + $(window).scrollTop();
    footHeight = $(".l-footer").innerHeight(); //footerの高さ（＝止めたい位置）
    if ( scrollHeight - scrollPosition  <= footHeight ) {
      $("#js-pageTop").css({
        "position":"absolute",
        "bottom": footHeight + 30
      });
    } else {
      $("#js-pageTop").css({
        "position":"fixed",
        "bottom": "30px"
      });
    }
  });
  $('#js-pageTop').on('click', function () {
    $('body,html').animate({
    scrollTop: 0
    }, 300);
    return false;
  });
});


